<template lang="pug">
.search-ia-dislike-container
  CustomDialogHeaderComponent(:headerTitle="TEXT.title")

  LexonTextAreaComponent(
    v-model="opinion"
    :label="TEXT.label"
    :placeholder="TEXT.placeholder"
    :maxlength="3000"
    validationRules="required"
  )

  CustomDialogActionButtonsComponent(
    :disabledButtons="!opinion.trim()"
    :mainAction="sendDislike"
    :primaryButtonText="TEXT.sendButton"
    :secondaryButtonText="TEXT.cancelButton"
  )
</template>

<script lang="ts">
import { Vue, Component } from 'vue-property-decorator'
import { Action } from 'vuex-class'
import { ModuleNamespaces } from '@/store/types/storeGlobalTypes'
import { DialogTypes } from '@/store/modules/dialog/dialogTypes'
import { useSearchIAStore } from '@/modules/documentSearcher/stores/useSearchIAStore'
import { TrackerEvents, trackEvent } from '@/plugins/tracker'

const dialogModule: string = ModuleNamespaces.DIALOG

@Component({
  components: {
    CustomDialogActionButtonsComponent: () =>
      import('@/components/Dialog/CustomDialog/CustomDialogActionButtonsComponent.vue'),
    CustomDialogHeaderComponent: () => import('@/components/Dialog/CustomDialog/CustomDialogHeaderComponent.vue'),
    LexonTextAreaComponent: () => import('@/components/forms/fields/LexonTextArea/LexonTextAreaComponent.vue')
  }
})
export default class SearchIADislikeDialogComponent extends Vue {
  @Action('closeCustomDialog', { namespace: dialogModule })
  closeCustomDialog!: () => void

  @Action('showDialog', { namespace: dialogModule })
  showDialogAction!: (payload: any) => void

  TEXT = {
    title: 'Queremos seguir mejorando',
    label: '¿Qué no ha ido bien en la respuesta?',
    placeholder: 'Escribe aquí los motivos',
    sendButton: 'Enviar',
    cancelButton: 'Cancelar',
    successMessage: 'Gracias por ayudarnos a mejorar.',
    genericError: this.$t('views.search_ia.genericError') as string
  }

  opinion = ''

  async sendDislike() {
    try {
      const searchIAStore = useSearchIAStore()
      trackEvent(TrackerEvents.AI_SEARCH_FEEDBACK_SUBMITTED, {
        feedback_message_ia_results: this.opinion,
        search_id: searchIAStore.search_id
      })

      await searchIAStore.dislikeAdvanceSearch({
        question: searchIAStore.lastQuery,
        opinion: this.opinion
      })

      this.showDialogAction({
        type: DialogTypes.SUCCESS,
        message: this.TEXT.successMessage
      })

      this.closeCustomDialog()
    } catch (_error) {
      this.showDialogAction({
        type: DialogTypes.ERROR,
        message: this.TEXT.genericError
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.search-ia-dislike-container {
  width: 100%;
  padding: 0;
}
.custom-dialog-action-buttons-container {
  margin-top: 16px;
}
</style>
